// sharedData/Observable.js
import { requestService } from "../requests/requestService";
import { sharedData } from "../sharedData/sharedData";

class EnhancedObservable {

  static instance;

  constructor(key) {
    this.key = key;
    this.subscribers = [];
  }

  get value() {
    return sharedData.get("diligenceStatus") || null;
  }

  set value(val) {
    sharedData.set("diligenceStatus", val);
  }

  get currentList() {
    return sharedData.get("diligenceObservable") || [];
  }

  set currentList(list) {
    sharedData.set("diligenceObservable", list);
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    return {
      unsubscribe: () => {
        this.subscribers = this.subscribers.filter(cb => cb !== callback);
      }
    };
  }

  notifySubscribers() {
    this.subscribers.forEach(cb => cb());
  }

  saveList() {
    sharedData.set("diligenceObservable", this.currentList);
  }

  saveValue() {
    sharedData.set("diligenceStatus", this.value)
  }

  createValue(value, ownerId) {
    return {
        value: value,
        by: ownerId,
        isEnhanced: value === "Enhanced" || value === "enhanced"
    }
  }

  isEnhanced() {
    return this.currentList.some(obj => obj.isEnhanced === true);
  }

  isEnahncedButNotBy(ownerId) {
    return this.currentList.some(obj => obj.isEnhanced === true && obj.by !== ownerId);
  }

  isEnhancedBy() {
    const obj = this.currentList.find(obj => obj.isEnhanced === true);
    return obj ? obj.by : null;
  }

  finalDiligence() {
    console.log("🔍 finalDiligence() called, currentList:", this.currentList);

    const mlnoOverride = this.currentList.find(obj => obj.by === 'mlnoOverride');
    if (mlnoOverride) {
        console.log("✅ MLNO override found, setting to:", mlnoOverride.value);
        this.setForce(mlnoOverride.value);
        return this.value;
    }

    if (this.isEnhanced()){
        console.log("✅ Enhanced status found, setting to Enhanced");
        this.setForce("Enhanced");
        return this.value;
    }
    else {
        // Priority: Enhanced > Simplified > Standard
        // First check for Simplified (should override Standard when conditions are met)
        for (let obj of this.currentList) {
            if (obj.value === "Simplified" || obj.value === "simplified"){
              console.log("✅ Simplified status found, setting final diligence to:", obj.value);
              this.setForce(obj.value);
              return this.value;
            }
        }
        // Then check for Standard (fallback)
        for (let obj of this.currentList) {
            if (obj.value === "Standard" || obj.value === "standard"){
              console.log("✅ Standard status found, setting final diligence to:", obj.value);
              this.setForce(obj.value);
              return this.value;
            }
        }

        console.log("⚠️ No valid diligence status found in currentList");
    }
  }

  setForce(value) {
    this.value = value;
  }

  saveValueToServer() {
    setTimeout(async ()=>{
      const response = await requestService.updateRequest({requestId: sharedData.get('requestId'), Diligence_Status: this.finalDiligence()});
      console.log(response);
    }, 500); //debounce to 1 second.
  } 

  setValue(value, ownerId) {
    const updatedList = [...this.currentList.filter(obj => obj.by !== ownerId), this.createValue(value, ownerId)];
    this.currentList = updatedList;

    // Immediately calculate and store the final diligence status
    this.finalDiligence();

    this.notifySubscribers();
    this.saveValueToServer();
  }

  getValue(ownerId) {
    return this.currentList.find(obj => obj.by === ownerId);
  }


  remove(ownerId) {
    this.currentList = this.currentList.filter(obj => obj.by !== ownerId);

    // Recalculate final diligence after removal
    this.finalDiligence();

    this.notifySubscribers();
    this.saveValueToServer();
  }

  removeByPrefix(prefix) {
    this.currentList = this.currentList.filter(obj => !obj.by.startsWith(prefix));

    // Recalculate final diligence after removal
    this.finalDiligence();

    this.notifySubscribers();
    this.saveValueToServer();
  }

  reset() {
    console.log("🔄 Resetting diligence observable - clearing all statuses");
    this.currentList = [];
    this.value = null;
    this.notifySubscribers();
  }

  static getInstance(key) {
    if (!this.instance) {
      this.instance = new EnhancedObservable(key);
    }
    return this.instance;
  }
}

export const diligenceObservable = EnhancedObservable.getInstance("diligenceStatus");